import React, { useState } from 'react';
import Header from './components/header/Header';
import Filter from './components/filter/Filter';
import Tabs from './components/tabs/Tabs';
import TicketList from './components/ticketList/TicketList';
import { TabsContext } from './context/tabsContext'
import { TicketsContext } from './context/ticketsContext';
import { tickets } from './services/aviasales';
import { FilterContext } from './context/filterContext';
import { filterTickes } from './utils/filterTickets'
import { sortItems } from './utils/sortItems'

function App() {
  const [tab, setTab] = useState('CHEAP');
  const [checkAll, setCheckAll] = useState(false)
  const [filters] = useState([
    {
      id: 0,
      name: 'Без остановок'
    },
    {
      id: 1,
      name: '1 пересадка'
    },
    {
      id: 2,
      name: '2 пересадки'
    },
    {
      id: 3,
      name: '3 пересадки'
    }
  ])

  const [filValues, setFilValues] = useState([0])

  const handleChange = (id, checked) => {

    if (checked) {
      if (checked && filValues.length === 3) {
        setCheckAll(true)
        setFilValues([...filValues, id])
      }
      setFilValues([...filValues, id])
    } else {
      setCheckAll(false)
      setFilValues(filValues.filter((item) => (item !== id)))
    }
  }

  const handleAllChange = (checked) => {
    if (checked) {
      setFilValues([0, 1, 2, 3])
      setCheckAll(true)
    } else {
      setFilValues([])
      setCheckAll(false)
    }
  }

  const ticketsData = filterTickes(sortItems(tickets, tab), filValues)

  return (
    <FilterContext.Provider value={{ filters, handleChange, filValues, handleAllChange, checkAll }}>
      <TicketsContext.Provider value={{ ticketsData }}>
        <TabsContext.Provider value={{ tab, setTab }}>
          <div className='container'>
            <Header />
            <div className="app__inner">
                <Filter />
              <div className='app__content'>
                <Tabs />
                <TicketList />
              </div>
            </div>
          </div>
        </TabsContext.Provider>
      </TicketsContext.Provider>
    </FilterContext.Provider>
  );
}

export default App;
